import { Injectable } from '@angular/core';
import { DataStateService } from './data-state.service';
import { UiStateService } from './ui-state-service';

@Injectable({
    providedIn: 'root'
})
export class CleanupService {
    constructor(private stateService: DataStateService, private uiService: UiStateService) { }

    public cleanup() {
        this.stateService.setModel(null);
        //this.uiService.cleanup();
    }
}
